import {error} from '.';
import {indicatorMetaBase} from '../config/environment.js';
import {fetchJson} from '../utils/fetch_utils';
import * as ActionTypes from './actionTypes';
import {updateIndicatorTimesAsyncPromise} from './update_indicator_times';

export const populateIndicatorDetailsAsyncPromise = () => {
  const now = new Date().toISOString();

  return (dispatch, getState) =>
    fetchJson(indicatorMetaBase + 'index.json?time=' + now)
    .then(data => {
      // First populate the basic details of the Indicators
      dispatch(_populateIndicatorDetails(data));

      // Then get the time meta-data for each Indicator
      const state = getState();
      const indicators = state.indicators.indicators;
      const promises = [];
      indicators.forEach((indicator) => {
        data.forEach(metadata => {
          if ((indicator.metadata_prefix || indicator.prefix) === metadata.prefix) {
            promises.push(new Promise((resolve) => {
              dispatch(updateIndicatorTimesAsyncPromise(indicator, state.time.valid_times, resolve));
            }));
          }
        });
      });
      return Promise.all(promises);
    })
    .catch(err => dispatch(error('Call to get Indicator details failed: ' + (err.message || err))));
};

const _populateIndicatorDetails = (data) => {
  return {
    type: ActionTypes.POPULATE_INDICATOR_DETAILS,
    indicators: data
  };
};



// WEBPACK FOOTER //
// ./src/actions/populate_indicator_details.js